import React from "react";

import logo from "../Assets/Logo.svg";

export const Bot = () => {
  return (
    <div className="container responsive-page-shell">
      <header className="header">
        <img className="logo-image" src={logo} alt="logo" />
        <div className="logo-text">
          <span className="C-logo">C</span>
          <span className="hezzle-logo">
            he<span className="Z-1">Z</span>
            <span className="Z-2">Z</span>le
          </span>
        </div>
      </header>
      <div className="gradient-line"></div>
      <div className="core-page-placeholder">Bot</div>
    </div>
  );
};

// import React, { useState, useEffect, useRef, useCallback } from "react";
// import { Chess } from "chess.js";
// import { Chessboard } from "react-chessboard";
// import { useNavigate } from "react-router-dom";
// import logo from "../Assets/Logo.svg";
// import { stockfishSocketService } from "./StockfishSocketService";

// export const Bot = () => {
//   const navigate = useNavigate();
//   const [game, setGame] = useState(new Chess());
//   const [moveHistory, setMoveHistory] = useState([]);

//   const [isGameOver, setIsGameOver] = useState(false);
//   const [gameResult, setGameResult] = useState(null);
//   const [isBotThinking, setIsBotThinking] = useState(false);

//   const engine = useRef(null);

//   useEffect(() => {
//     if (!stockfishSocketService.isConnected) {
//       stockfishSocketService.connect();
//     }
//   }, []);

//   useEffect(() => {
//     try {
//       engine.current = new Worker("/stockfish.js");
//       engine.current.onmessage = (event) => {
//         const message = event.data;
//         if (message.startsWith("bestmove")) {
//           const bestMoveUci = message.split(" ")[1];
//           if (bestMoveUci && bestMoveUci !== "(none)") {
//             applyBotMove(bestMoveUci);
//           }
//           setIsBotThinking(false);
//         }
//       };
//       engine.current.postMessage("uci");
//       engine.current.postMessage("isready");
//     } catch (error) {
//       console.error("Failed to load stockfish.js", error);
//     }
//     return () => {
//       if (engine.current) engine.current.terminate();
//     };
//   }, []);

//   const applyBotMove = useCallback((uciMove) => {
//     setGame((prevGame) => {
//       const gameCopy = new Chess();
//       gameCopy.loadPgn(prevGame.pgn());

//       const from = uciMove.substring(0, 2);
//       const to = uciMove.substring(2, 4);
//       const promotion = uciMove.length === 5 ? uciMove[4] : undefined;

//       try {
//         const move = gameCopy.move({
//           from,
//           to,
//           promotion: promotion || "q",
//         });

//         if (move) {
//           setMoveHistory((prev) => [...prev, move.san]);
//           if (gameCopy.isGameOver()) {
//             handleGameOver(gameCopy);
//           }
//           return gameCopy;
//         }
//       } catch (e) {
//         console.error("Bot tried illegal move:", uciMove);
//       }
//       return prevGame;
//     });
//   }, []);

//   const makeBotMove = (currentFen) => {
//     if (!engine.current || isGameOver) return;
//     setIsBotThinking(true);
//     engine.current.postMessage(`position fen ${currentFen}`);
//     engine.current.postMessage("go depth 15");
//   };

//   const onDrop = (sourceSquare, targetSquare, piece) => {
//     if (isGameOver || isBotThinking) return false;

//     try {
//       const gameCopy = new Chess();
//       gameCopy.loadPgn(game.pgn());

//       const move = gameCopy.move({
//         from: sourceSquare,
//         to: targetSquare,
//         promotion: piece[1].toLowerCase() ?? "q",
//       });

//       if (move === null) return false;

//       setGame(gameCopy);
//       setMoveHistory((prev) => [...prev, move.san]);

//       if (gameCopy.isGameOver()) {
//         handleGameOver(gameCopy);
//       } else {
//         setTimeout(() => {
//           makeBotMove(gameCopy.fen());
//         }, 500);
//       }
//       return true;
//     } catch (e) {
//       return false;
//     }
//   };
//   const handleGameOver = (gameInstance) => {
//     setIsGameOver(true);
//     if (gameInstance.isCheckmate()) {
//       setGameResult(
//         gameInstance.turn() === "w" ? "Black Wins (Bot)" : "White Wins (You)"
//       );
//     } else if (gameInstance.isDraw()) {
//       setGameResult("Draw");
//     } else {
//       setGameResult("Game Over");
//     }
//   };

//   const resetGame = () => {
//     const newGame = new Chess();
//     setGame(newGame);
//     setMoveHistory([]);
//     setIsGameOver(false);
//     setGameResult(null);
//     setIsBotThinking(false);
//     if (engine.current) engine.current.postMessage("stop");
//   };

//   const handleGeneratePuzzles = () => {
//     const username = localStorage.getItem("username") || "User";

//     game.header("White", username);
//     game.header("Black", "Stockfish Bot");
//     game.header("Event", "Play vs Bot");

//     const pgn = game.pgn();

//     const gamePayload = {
//       pgn: pgn,
//       url: `bot-game-${Date.now()}`,
//       source: "manual-import",
//       white: username,
//       black: "Stockfish Bot",
//     };

//     const userData = {
//       username: username,
//       chesscomUsername: username,
//       lichessUsername: "ImportUser",
//     };

//     console.log("[Bot] Sending game for puzzle generation...");

//     if (stockfishSocketService.isConnected) {
//       stockfishSocketService.send("start_puzzle_generation", {
//         games: [gamePayload],
//         userData: userData,
//       });

//       navigate("/PersonalisedPuzzles?puzzle=1");
//     } else {
//       alert("Connection to server lost. Please check internet or refresh.");
//     }
//   };

//   return (
//     <div
//       className="container"
//       style={{ display: "flex", flexDirection: "column", height: "100vh" }}
//     >
//       <header className="header">
//         <img className="logo-image" src={logo} alt="logo" />
//         <div className="logo-text">
//           <span className="C-logo">C</span>
//           <span className="hezzle-logo">
//             he<span className="Z-1">Z</span>
//             <span className="Z-2">Z</span>le
//           </span>
//         </div>
//       </header>
//       <div className="gradient-line"></div>

//       <div
//         style={{
//           flex: 1,
//           display: "flex",
//           flexDirection: "row",
//           justifyContent: "center",
//           alignItems: "center",
//           gap: "40px",
//           padding: "20px",
//         }}
//       >
//         <div
//           style={{
//             width: "70vh",
//             height: "70vh",
//             maxWidth: "600px",
//             maxHeight: "600px",
//           }}
//         >
//           <Chessboard
//             position={game.fen()}
//             onPieceDrop={onDrop}
//             boardOrientation="white"
//             arePiecesDraggable={!isBotThinking && !isGameOver}
//           />
//         </div>

//         <div
//           style={{
//             width: "300px",
//             height: "70vh",
//             backgroundColor: "#f4f4f4",
//             borderRadius: "8px",
//             padding: "20px",
//             display: "flex",
//             flexDirection: "column",
//             justifyContent: "space-between",
//           }}
//         >
//           <div>
//             <h2
//               style={{ borderBottom: "1px solid #ccc", paddingBottom: "10px" }}
//             >
//               Play vs Bot
//             </h2>

//             {isGameOver ? (
//               <div
//                 style={{
//                   backgroundColor: "#e8f5e9",
//                   padding: "15px",
//                   borderRadius: "5px",
//                   border: "1px solid #28a745",
//                   marginBottom: "20px",
//                 }}
//               >
//                 <h3 style={{ margin: 0, color: "#28a745" }}>{gameResult}</h3>
//                 <p>Game Finished.</p>

//                 <button
//                   style={{
//                     width: "100%",
//                     padding: "10px",
//                     marginTop: "10px",
//                     backgroundColor: "#4F3B7B",
//                     color: "white",
//                     border: "none",
//                     borderRadius: "4px",
//                     cursor: "pointer",
//                     fontWeight: "bold",
//                   }}
//                   onClick={handleGeneratePuzzles}
//                 >
//                   Generate Puzzles 🚀
//                 </button>
//               </div>
//             ) : (
//               <div style={{ marginBottom: "15px" }}>
//                 <p style={{ fontSize: "1.1em", marginBottom: "5px" }}>
//                   Status:{" "}
//                   <strong>
//                     {isBotThinking ? "Bot is thinking..." : "Your Turn"}
//                   </strong>
//                 </p>
//                 {isBotThinking && (
//                   <div
//                     style={{
//                       height: "4px",
//                       width: "100%",
//                       backgroundColor: "#ddd",
//                       borderRadius: "2px",
//                       overflow: "hidden",
//                     }}
//                   >
//                     <div
//                       style={{
//                         height: "100%",
//                         width: "50%",
//                         backgroundColor: "#4F3B7B",
//                         animation: "loading 1s infinite",
//                       }}
//                     ></div>
//                   </div>
//                 )}
//               </div>
//             )}

//             <div
//               style={{
//                 maxHeight: "300px",
//                 overflowY: "auto",
//                 background: "#be7474ff",
//                 padding: "10px",
//                 borderRadius: "4px",
//                 border: "1px solid #ccc",
//               }}
//             >
//               <strong>Moves:</strong>
//               <p
//                 style={{
//                   fontFamily: "monospace",
//                   fontSize: "0.9em",
//                   lineHeight: "1.5",
//                 }}
//               >
//                 {moveHistory.map((move, index) => (
//                   <span key={index} style={{ marginRight: "5px" }}>
//                     {index % 2 === 0 ? `${Math.floor(index / 2) + 1}.` : ""}{" "}
//                     {move}
//                   </span>
//                 ))}
//               </p>
//             </div>
//           </div>

//           <div>
//             <button
//               onClick={resetGame}
//               disabled={isBotThinking}
//               style={{
//                 width: "100%",
//                 padding: "12px",
//                 backgroundColor: isBotThinking ? "#ccc" : "#6c757d",
//                 color: "white",
//                 border: "none",
//                 borderRadius: "4px",
//                 cursor: isBotThinking ? "not-allowed" : "pointer",
//                 fontSize: "1em",
//               }}
//             >
//               New Game
//             </button>
//             <button
//               onClick={() => navigate("/")}
//               style={{
//                 width: "100%",
//                 padding: "12px",
//                 marginTop: "10px",
//                 backgroundColor: "transparent",
//                 color: "#333",
//                 border: "1px solid #ccc",
//                 borderRadius: "4px",
//                 cursor: "pointer",
//               }}
//             >
//               Back to Home
//             </button>
//           </div>
//         </div>
//       </div>
//       <style>{`
//         @keyframes loading {
//           0% { margin-left: -50%; }
//           100% { margin-left: 100%; }
//         }
//       `}</style>
//     </div>
//   );
// };
